import { ComponentProps, ForwardedRef, forwardRef } from 'react'
import { Radio, FormControlLabel } from 'ui-components-web'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type FormRadioProps = ComponentProps<typeof Radio> & {
  label?: string
  className?: string
  buttonClassName?: string
}

const FormRadio = forwardRef<ForwardedRef<HTMLButtonElement>, FormRadioProps>(
  ({ label = '', className = '', buttonClassName = '', ...props }, ref) => {
    return (
      <FormControlLabel
        className={classNames('ml-0 mr-0', className)}
        control={<Radio ref={ref} {...props} className={buttonClassName} />}
        label={label}
      />
    )
  },
)

FormRadio.displayName = 'FormRadio'

export default FormRadio
